import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { apiSlice } from 'api/apiSlice'
import { authReducer } from 'store/authSlice'
import { favoritesReducer } from 'store/favoritesSlice'
import { featureFlagsReducer } from 'store/featureFlagsSlice'
import { offersReducer } from 'store/offersSlice'

export const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  favorites: favoritesReducer,
  features: featureFlagsReducer,
  offers: offersReducer,
})

let store: ReturnType<typeof configureStore<RootState>> | undefined

export const getStoreInstance = (preloadedState: Partial<RootState> = {}) => {
  if (store) return store

  // Create store only once
  store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
    preloadedState,
    reducer: rootReducer,
  })

  return store
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof getStoreInstance>
export type AppDispatch = AppStore['dispatch']
